<ul class="statuses-row m-0" style="text-align: left">
  <li
    *ngFor="let status of statusLegend; let i = index"
    [ngStyle]="{ 'margin-left': i === 0 ? '-3px' : '0' }"
    [style.color]="status.color"
    style="font-weight: 500"
  >
    <span [ngClass]="status.class" style="margin-right: 4px"></span
    >{{ lextranslate.i18n[status.label] }}
  </li>
</ul>
